import * as React from 'react';
import Quiz, { QuizState } from 'globals/components/quiz/quiz';
import Legend from 'components/legend/legend';
import Maps from 'components/maps/maps';

const SCORE = 1000;

export default class MapsQuiz extends React.PureComponent {

    correct: boolean[];

    constructor(props: {}) {
        super(props);
        this.calculateRoundScore = this.calculateRoundScore.bind(this);
        this.renderMapsQuiz = this.renderMapsQuiz.bind(this);
        this.updateResponses = this.updateResponses.bind(this);
    }

    /**
     * Calculate the score of the previous round.
     * @param state The quiz state after a round is completed.
     * @returns     Array of score details.
     */
    calculateRoundScore(state: QuizState): RoundScore[] {

        // There can be any number of countries. A perfect round will have as many countries in the right position
        // as there are countries in total.
        const correctCount = this.correct.reduce((previous, current) => previous + (current ? 1 : 0), 0);
        const countryCount = state.rounds[state.roundIndex].countries.length;

        // See if the player has every country in the right location, or at least some of them.
        const roundScores: RoundScore[] = [];
        if (correctCount === countryCount) {
            roundScores.push({ label: 'Correct', score: SCORE });
        } else if (correctCount > 0) {
            const score = ((SCORE / countryCount) * correctCount) * 0.9;
            roundScores.push({ label: 'Partial', score });
        }

        return roundScores;

    }

    /**
     * Render the quiz component which should render the maps quiz.
     */
    render(): JSX.Element {
        return (
            <Quiz
                bufferMilliseconds={7000}
                scoreMilliseconds={15000}
                calculateRoundScore={this.calculateRoundScore}
                render={this.renderMapsQuiz}
            />
        );
    }

    /**
     * Render a series of maps.
     * @param state The state from the parent component.
     */
    renderMapsQuiz(state: QuizState): JSX.Element {
        return (
            <React.Fragment>
                <Legend />
                <Maps
                    isRoundInterval={state.isRoundInterval}
                    roundIndex={state.roundIndex}
                    round={state.rounds[state.roundIndex]}
                    rounds={state.rounds}
                    updateResponses={this.updateResponses}
                />
            </React.Fragment>
        );
    }

    /**
     * Record correctly ordered maps.
     * @param correct Array of maps in the correct position.
     */
    updateResponses(correct: boolean[]) {
        this.correct = correct;
    }

}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/components/maps-quiz/maps-quiz.tsx